<template>
  <div>
    <el-dialog
      :id="$options.name"
      :before-close="noDialog"
      :fullscreen="dialogFullscreen"
      :visible.sync="dialog"
      title="新增设备"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="params"
        :model="chargingPileEditDTO"
        :rules="rules"
        label-width="auto"
      >
        <el-row>
          <el-col :span="12" :xs="24">
            <el-form-item label="所属小区" prop="groupId">
              <el-input
                v-if="defaultGroupId"
                v-model="defaultGroupName"
                placeholder="请输入设备名称"
                disabled
              />
              <el-select
                v-else
                v-model="chargingPileEditDTO.groupId"
                filterable
                ref="select"
                @focus="closeReadOnly"
                @hook:mounted="closeReadOnly"
                @visible-change="closeReadOnly"
              >
                <el-option
                  v-for="item in GroupList"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" :xs="24">
            <el-form-item label="设备名称" prop="name">
              <el-input
                v-model="chargingPileEditDTO.name"
                placeholder="示例：1栋1号机"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" :xs="24">
            <el-form-item label="设备序号" prop="plot">
              <el-input
                v-model.number="chargingPileEditDTO.plot"
                placeholder="请输入设备序号"
              >
                <template slot="append">号</template>
              </el-input>
            </el-form-item>
          </el-col> -->
        </el-row>

        <!-- <el-form-item label="位置信息" prop="address">
          <el-row>
            <template v-if="records !== undefined">
              <el-col :span="6" :xs="12">
                {{ records.detail.addressComponents.province }}
              </el-col>
              <el-col :span="6" :xs="12">
                {{ records.detail.addressComponents.city }}
              </el-col>
              <el-col :span="6" :xs="12">
                {{ records.detail.addressComponents.district }}
              </el-col>
            </template>
            <el-col :span="6" :xs="12">
              <el-button plain type="primary" @click="mapDialog = true"
                >点击进行定位</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="具体位置" prop="address">
          <el-input
            v-model="chargingPileEditDTO.address"
            placeholder="请输入设备详细地址"
          />
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="chargingPileEditDTO.mobile"
            maxlength="11"
            placeholder="请输入联系人手机号"
          />
        </el-form-item> -->
        <!-- 
        <el-row>
          <el-col :span="8" :xs="14">
            <el-form-item label="收费方式">
              <el-button @click="chargeDialog=true">{{ chargeValue }}</el-button>
            </el-form-item>
          </el-col> 
          <el-col :span="6" :xs="10 ">
            <el-button type="success" @click="addTemplateDialog=true">创建收费方式</el-button>
          </el-col>
        </el-row> -->
        <!-- <el-form-item label="电费分润" prop="electricityBillUserId">
          <el-row>
            <el-col :span="1" :xs="24">
              <el-checkbox v-model="eShow"/>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-select
                  v-model="chargingPileEditDTO.electricityBillUserId"
                  :disabled="!eShow" placeholder="请输电费分润方">
                <el-option
                    v-for="x in recordsDividend"
                    :key="x.value"
                    :label="x.name"
                    :value="x.id"
                />
              </el-select>
            </el-col>
          </el-row>
        </el-form-item> -->
        <!-- <el-row v-for="(item, index) in  chargingPileEditDTO.chargingPileInsertDividendDTOList" :key="index">
          <el-col :span="9" :xs="24">
            <el-form-item label="分润方">
              <el-select v-model="item.dividendId" placeholder="请选择分润方">
                <el-option
                    v-for="x in recordsDividend"
                    :key="x.value"
                    :disabled="disabled(x,chargingPileEditDTO.chargingPileInsertDividendDTOList)"
                    :label="x.name"
                    :value="x.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9" :xs="24">
            <el-form-item :prop="'chargingPileInsertDividendDTOList.'+index+'.dividendRatio'"
                          :rules="rules.dividendRatio"
                          label="分润比例">
              <el-input v-model.number="item.dividendRatio" maxlength="3"
                        placeholder="请输分润比例">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="index===0&&chargingPileEditDTO.chargingPileInsertDividendDTOList.length" :span="3"
                  :xs="{span:8,offset:6}">
            <el-button
                @click="listReset(chargingPileInsertDividendDTOList,item)">清空
            </el-button>
          </el-col>
          <el-col v-if="index>0" :span="3" :xs="{span:8,offset:6}">
            <el-button @click="listRemove(chargingPileInsertDividendDTOList,item)">删除</el-button>
          </el-col>
          <el-col :span="3" :xs="8" class="m-mb-10">
            <el-button @click="listAdd(chargingPileInsertDividendDTOList)">新增</el-button>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12" :xs="24">
            <el-form-item label="硬件UID" prop="ids">
              <el-input
                v-model="chargingPileEditDTO.ids"
                placeholder="请扫码获取硬件UID"
              >
                <el-button slot="append" @click="scanIds">扫码</el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-row>
              <el-col :span="19">
                <el-form-item label="设备类型">
                  <el-select
                    v-model="chooseDeviceVersion"
                    placeholder="修改设备类型"
                  >
                    <el-option
                      v-for="x in deviceVersionList"
                      :key="x.type"
                      :label="x.name"
                      :value="x.type"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-button type="warning" @click="editDeviceSocketNum"
                  >修改</el-button
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12" :xs="24">
            <el-form-item label="插座二维码">
              <el-row class="t-c">
                <el-col :span="12" style="text-align: center">
                  <template v-if="chargingPileEditDTO.socketSize === undefined">
                    扫码后获取数量
                  </template>
                  <span v-else class="QT">{{
                    chargingPileEditDTO.socketSize
                  }}</span>
                </el-col>
                <el-col :span="12">
                  <el-button type="warning" @click="bindDialog = true"
                    >绑定</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="独立二维码">
              <el-row class="t-c">
                <!-- <el-col :span="6" :xs="12" class="xs-m-p"> 独立二维码 </el-col> -->
                <el-col :span="24">
                  <el-button type="warning" @click="qtBind">绑定</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="noDialog">取消</el-button>
        <el-button type="primary" @click="post">提交</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="chargeDialog"
      title="收费方式"
    >
      <el-table
        :data="AppTemplate"
        highlight-current-row
        @current-change="handleCurrentChange"
      >
        <el-table-column label="名称" prop="name" />
        <el-table-column label="计费价格">
          <template #default="scope"> {{ scope.row.powerFare }}元 </template>
        </el-table-column>
        <el-table-column label="起步价">
          <template #default="scope"> {{ scope.row.startingFare }}元 </template>
        </el-table-column>
        <el-table-column label="计费方式">
          <template #default="scope">
            {{ scope.row.chargeType === "1" ? "按时间" : "按度数" }}
          </template>
        </el-table-column>
        <el-table-column label="计费清单" prop="billingList">
          <template #default="scope">
            <template v-if="scope.row.chargeType === '1'">
              <div
                v-for="(item, index) in scope.row.chargeTemplateInfoList"
                :key="index"
              >
                {{ item.startPower }}~{{ item.endPower }} {{ item.money }}元/{{
                  item.interval
                }}分钟
              </div>
            </template>
            <span v-else-if="scope.row.chargeType === '2'"
              >{{ scope.row.powerFare }}元/度</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="chargeDialog = false">取消</el-button>
        <el-button @click="chargeDialog = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      ref="monthTable"
      :fullscreen="dialogFullscreen"
      :visible.sync="monthDialog"
      title="包月方式"
    >
      <el-table
        :data="recordsMonthly"
        highlight-current-row
        @current-change="handleMonth"
      >
        <el-table-column label="名称" prop="name" />
        <el-table-column label="计费清单">
          <template #default="scope">
            <div
              v-for="(item, index) in JSON.parse(scope.row.monehlyInfo)"
              :key="index"
            >
              {{ item.startPower }}~{{ item.endPower }}瓦 {{ item.money }}元/{{
                item.freeDayNum
              }}天/{{ item.freeChargeNum }}次
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="monthDialog = false">取消</el-button>
        <el-button type="primary" @click="monthDialog = false">确定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="bindDialog"
      title="二维码绑定"
    >
      <el-table :data="chargingPileEditDTO.qrCodeList">
        <el-table-column label="端口号" prop="socketNum" />
        <el-table-column label="操作">
          <template #default="scope">
            <el-button
              v-if="scope.row.qrCodeUrl !== undefined"
              size="small"
              type="danger"
              @click="unbind(scope.row.socketNum)"
              >解绑
            </el-button>
            <el-button
              v-else
              plain
              size="small"
              type="primary"
              @click="socketBind(scope.row.socketNum)"
            >
              扫码绑定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="bindDialog = false">确定</el-button>
      </div>
    </el-dialog>
    <map-dialog :dialog="mapDialog" />
    <add-template-dialog :dialog="addTemplateDialog" />
    <add-monthly-template :dialog="addMonthlyTemplate" />
  </div>
</template>

<script>
// import getAgentAllDevidend from "@/api/user/dividend-manage/getAgentAllDevidend";
// import agentGetTheOwnChargeTemplate from "@/api/device/charge-template-manage/agentGetTheOwnChargeTemplate";
// import agentGetTheOwnAllMonthlyTemplate from "@/api/device/monthly-template-manage/agentGetTheOwnAllMonthlyTemplate";
import DeviceQRCodeController from "@/api/device/DeviceQRCodeController";
import agentBindDevice from "@/api/device/charging-pile-manage/agentBindDevice";
import agentEditDeviceSocketSize from "@/api/device/charging-pile-manage/agentEditDeviceSocketSize";
import agentGetDeviceInfoBySn from "@/api/device/charging-pile-manage/agentGetDeviceInfoBySn";
import getAllDeviceType from "@/api/device/charging-pile-manage/agentGetDeviceVersionList";
import getGroupList from "@/api/device/device-group-manage/getGroupList";
import agentChangeDeviceQRCode from "@/api/device/device-qr-code-controler/agentChangeDeviceQRCode";
import agengUnBindQrCode from "@/api/device/socket-qrcode-manage/agengUnBindQrCode";
import agentBindQrCode from "@/api/device/socket-qrcode-manage/agentBindQrCode";
import AddMonthlyTemplate from "@/components/Dialog/addMonthlyTemplate";
import AddTemplateDialog from "@/components/Dialog/addTemplateDialog";
import MapDialog from "@/components/Dialog/mapDialog";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import dividendMixin from "@/mixin/dividendMixin";
import resDispose from "@/mixin/resDisposeMixin";
import scanMixin from "@/mixin/scanMixin";
import utilsMixin from "@/mixin/utilsMixin";
import { dividendRatio, num } from "@/utils/check";
import { getQueryArgs } from "@/utils/utils";
import { Message } from "element-ui";

export default {
  name: "addPowerStationDialog",
  components: { AddTemplateDialog, AddMonthlyTemplate, MapDialog },
  props: {
    defaultGroupId: {
      type: Number,
      default: 0,
    },
  },
  mixins: [
    dialogMixin,
    createdMixin,
    resDispose,
    scanMixin,
    dividendMixin,
    utilsMixin,
  ],
  watch: {
    radio(newV) {
      if (newV !== "否") {
        this.monthDialog = true;
      } else {
        this.monthValue = "选择包月方式";
        this.params.monthlyTemplateId = undefined;
      }
    },
    eShow(newV) {
      if (newV === false) {
        this.resetElectricityId();
      }
    },
  },
  created() {
    getGroupList().then((res) => {
      this.GroupList = res.data;
      const group = this.GroupList.find((g) => g.id == this.defaultGroupId);
      if (group) {
        this.defaultGroupName = group.groupName;
        this.chargingPileEditDTO.groupId = group.id;
      }
    });

    // this.sn = "869476054694825";
    // this.initBySn("869476054694825");
  },
  mounted() {
    // this.refresh.$on("mapDialog", (records) => {
    //   this.records = records;
    //   console.log(records.detail, 398);
    //   this.chargingPileEditDTO.address = records.detail.address;
    //   this.chargingPileEditDTO.lat = records.detail.location.lat;
    //   this.chargingPileEditDTO.lng = records.detail.location.lng;
    //   this.chargingPileEditDTO.province =
    //     records.detail.addressComponents.province;
    //   this.chargingPileEditDTO.district =
    //     records.detail.addressComponents.district;
    //   this.chargingPileEditDTO.city = records.detail.addressComponents.city;
    //   this.mapDialog = false;
    // });
  },
  data() {
    return {
      defaultGroupName: "",
      sn: "",
      addMonthlyTemplate: false,
      addTemplateDialog: false,
      records: undefined,
      GroupList: [],
      mapDialog: false,
      bindDialog: false,
      rules: {
        ids: [{ required: true, message: "请扫码获取IDS" }],
        name: [{ required: true, message: "请输入设备名称" }],
        groupId: [{ required: true, message: "请选择所属小区" }],
        // plot: [
        //   { required: true, message: "请输入设备编号" },
        //   { type: "number", message: "设备编号必须为数数字" },
        //   {
        //     validator: noZero,
        //   },
        // ],
        address: [{ required: true, message: "请输具体位置" }],
        mobile: [
          { required: true, message: "请输电话号码" },
          { validator: num },
        ],
        dividendRatio: [
          { type: "number", message: "必须为数字值" },
          { validator: dividendRatio },
        ],
      },
      eShow: false,
      chargingPileEditDTO: {
        // electricityBillUserId: undefined,
        // district: undefined,
        // plot: undefined,
        qrCodeList: [],
        socketSize: undefined,
        ids: undefined,
        // chargeMaxTime: 10,
        name: undefined,
        // mobile: undefined,
        // maxPower: 1000,
        // powerSettings: 2,
        // costOfPowerFare: 0.5,
        // lat: undefined,
        // lng: undefined,
        groupId: undefined,
        // address: undefined,
        // chargingPileInsertDividendDTOList: [
        //   {
        //     dividendId: undefined,
        //     dividendRatio: undefined,
        //   },
        // ],
      },
      outage: [
        { value: 1, label: "充满自停" },
        { value: 2, label: "误拔断电" },
        { value: 3, label: "定时充电" },
      ],
      AppTemplate: [
        {
          chargeTemplateInfoList: [
            {
              endPower: 0,
              interval: 0,
              money: 0,
              startPower: 0,
              tempId: 0,
            },
          ],
          chargeType: "",
          id: 0,
          name: "",
          powerFare: 0,
          returnTheBalance: "",
          startingFare: 0,
        },
      ],
      chargeValue: "选择收费方式",
      monthValue: "选择包月方式",
      chargeDialog: false,
      monthDialog: false,
      radio: "否",
      address: [],
      recordsMonthly: [
        {
          monehlyInfo: undefined,
          name: undefined,
        },
      ],
      recordsDividend: [],
      params: {
        chargeTemplateId: undefined,
        monthlyTemplateId: undefined,
      },
      //修改设备插座数量
      deviceVersionList: [],
      chooseDeviceVersion: undefined,
    };
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    resetElectricityId() {
      this.chargingPileEditDTO.electricityBillUserId = undefined;
    },
    fetchData() {
      // agentGetTheOwnChargeTemplate().then((res) => {
      //   this.AppTemplate = res.data;
      // });
      // agentGetTheOwnAllMonthlyTemplate().then((res) => {
      //   this.recordsMonthly = res.data;
      // });
      // getAgentAllDevidend().then((res) => {
      //   this.recordsDividend = res.data;
      // });
    },
    scanIds() {
      console.log("log1");
      this.scan({
        callBack: (res) => {
          console.log("log2", res);
          if (res.resultStr.substring(0, 4) === "http") {
            let strList = res.resultStr.split("?");
            if (strList.length === 2) {
              let argList = strList[1].split("&");
              if (argList.length === 2) {
                if (argList[0] === "type=device") {
                  console.log(argList[1].split("=")[1].substring(0, 32));
                  DeviceQRCodeController.getDeviceByCode(
                    argList[1].split("=")[1].substring(0, 32)
                  ).then((res) => {
                    this.resDisposeWithoutSuccessMsg({
                      res,
                      success: () => {
                        console.log("log4", res);

                        this.sn = res.data.sn;
                        this.initBySn(res.data.sn);
                      },
                    });
                  });
                } else {
                  Message.error("二维码错误");
                }
              } else {
                Message.error("二维码错误");
              }
            } else {
              Message.error("二维码错误");
            }
          } else {
            console.log("log3", res);

            this.sn = res.resultStr;
            this.initBySn(res.resultStr);
          }
        },
      });
    },
    socketBind(socketNum) {
      if (!this.chargingPileEditDTO.id) {
        Message({
          message: "请扫码获取ids",
          type: "error",
          duration: 3 * 1000,
        });
      } else {
        this.scan({
          callBack: (res) => {
            agentBindQrCode(
              getQueryArgs(res.resultStr)["code"],
              this.chargingPileEditDTO.id,
              socketNum
            ).then((res2) => {
              this.resDispose({
                res: res2,
                success: () => {
                  this.chargingPileEditDTO.qrCodeList[socketNum - 1].qrCodeUrl =
                    getQueryArgs(res.resultStr)["code"];
                },
              });
            });
          },
        });
      }
    },
    qtBind() {
      if (!this.chargingPileEditDTO.id) {
        Message({
          message: "请扫码获取ids",
          type: "error",
          duration: 3 * 1000,
        });
      } else {
        this.scan({
          callBack: (res) => {
            agentChangeDeviceQRCode(
              getQueryArgs(res.resultStr)["code"].substring(0, 32),
              this.chargingPileEditDTO.id
            ).then((res2) => {
              this.resDispose({ res: res2 });
            });
          },
        });
      }
    },
    unbind(socketNum) {
      agengUnBindQrCode(this.chargingPileEditDTO.id, socketNum).then((res) => {
        this.resDispose({
          res,
          success: () => {
            this.chargingPileEditDTO.qrCodeList[socketNum - 1].qrCodeUrl =
              undefined;
          },
        });
      });
    },
    post() {
      // if (this.params.chargeTemplateId === undefined) {
      //   Message({
      //     message: "请选择收费方式",
      //     type: 'error',
      //     duration: 3 * 1000
      //   });
      //   return false
      // }
      // if (this.records === undefined) {
      //   Message({
      //     message: "定位获取经纬度",
      //     type: "error",
      //     duration: 3 * 1000,
      //   });
      //   return false;
      // }
      this.$refs["params"].validate((valid) => {
        if (valid) {
          // 删除无用字段
          let Dto = { ...this.chargingPileEditDTO };
          // Dto.name = Dto.name + "-" + Dto.plot;
          // delete Dto.plot;
          delete Dto.qrCodeList;
          delete Dto.id;
          delete Dto.socketSize;
          // if (
          //   Dto.chargingPileInsertDividendDTOList.length === 1 &&
          //   Dto.chargingPileInsertDividendDTOList[0].dividendId === undefined
          // ) {
          //   delete Dto.chargingPileInsertDividendDTOList;
          // }
          // if (Dto.electricityBillUserId === undefined) {
          //   Dto.electricityBillUserId = 0;
          // }
          this.loadStart();
          agentBindDevice(Dto)
            .then((res) => {
              this.resEditNoDialog({ res });
              console.log(this);
            })
            .finally(() => {
              this.loadDialog.close();
            });
        }
      });
    },
    editDeviceSocketNum() {
      if (this.chooseDeviceVersion) {
        agentEditDeviceSocketSize({
          model: this.chooseDeviceVersion,
          ids: this.chargingPileEditDTO.ids,
        }).then((res) => {
          // Message({
          //   message: "修改成功~",
          //   type: "success",
          //   duration: 2 * 1000,
          // });
          this.resEditNoDialog({ res });

          this.initBySn(this.sn);
        });
      }
    },
    initBySn(sn) {
      this.chargingPileEditDTO.qrCodeList = [];
      agentGetDeviceInfoBySn(btoa(unescape(encodeURIComponent(sn)))).then(
        (res) => {
          if (res.code === 1) {
            //获取设备类型列表
            this.chargingPileEditDTO.ids = res.data.ids;
            this.chargingPileEditDTO.id = res.data.id;
            this.chargingPileEditDTO.socketSize = res.data.socketSize;
            this.chooseDeviceVersion = res.data.versions;
            getAllDeviceType().then((res2) => {
              this.deviceVersionList = res2;
            });
            for (let i = 1; i < res.data.socketSize + 1; i++) {
              let hasKey = false;
              for (let k = 0; k < res.data.qrCodeList.length; k++) {
                if (res.data.qrCodeList[k].socketNum === i) {
                  hasKey = true;
                  this.chargingPileEditDTO.qrCodeList.push({
                    socketNum: i,
                    qrCodeUrl: res.data.qrCodeList[k].qrCodeUrl,
                  });
                }
              }
              if (!hasKey) {
                this.chargingPileEditDTO.qrCodeList.push({
                  socketNum: i,
                  qrCodeUrl: undefined,
                });
              }
            }
          } else {
            Message({
              message: res.msg,
              type: "error",
              duration: 3 * 1000,
            });
          }
        }
      );
    },
    handleCurrentChange(val) {
      this.params.chargeTemplateId = val.id;
      this.chargeValue = "当前已选" + val.name;
    },
    no() {
      this.params.monthlyTemplateId = undefined;
    },
    handleMonth(val) {
      this.params.monthlyTemplateId = val.id;
      this.monthValue = "当前已选" + val.name;
      this.radio = this.monthValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item__content button {
  width: auto !important;
}

.QT {
  margin-right: 20px;
}
</style>
